<template>
    <div>
        <rkm-form
            v-if="data.additionals.permiteEdicao && !processoDevolvido"
            ref="Form"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.material"
                        :request-query-string-params="queryStringParams.material"
                        :search-fields="fields.autocomplete.material"
                        :validations="validations.material"
                        label="Medicamento"
                        text-field="descricaoCompleta"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-form-select
                        :options="data.form.meses"
                        :validations="validations.mes"
                        label="Quantidade de mês(es)"
                        v-model="form.mesValue"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-form ref="FormMeses">
            <rkm-table
                v-for="(medicamentoItem, medicamentoIndex) in data.model.itens"
                :class="{ 'mb-3': medicamentoIndex < data.model.itens.length - 1 }"
                :fields="fields.table.meses"
                :items="medicamentoItem.meses"
                :key="medicamentoIndex"
                class="table-meses"
                hide-filters
                hide-pagination
            >
                <template #beforeTable>
                    <div class="table-meses-header-footer d-flex justify-content-between align-items-center">
                        <span>{{ medicamentoItem.material.descricaoCompleta }}</span>

                        <div>
                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao || processoDevolvido"
                                @click="addMes(medicamentoItem, getNumeroProximoMes(medicamentoItem))"
                                color="primary"
                                small
                            >
                                Adicionar mês
                            </rkm-button>

                            <rkm-button
                                :disabled="!data.additionals.permiteEdicao || processoDevolvido"
                                @click="excluir(medicamentoItem, medicamentoIndex)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </div>
                    </div>
                </template>

                <template v-slot:cell(mes)="{ value }">
                    {{ value }}º mês
                </template>

                <template v-slot:cell(quantidadeSolicitada)="{ index, item }">
                    <rkm-form-input
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido"
                        :validations="getTableValidation(item, 'quantidadeSolicitada')"
                        :value="item.quantidadeSolicitada"
                        @change="handleQuantidadeSolcitadaChange(index, item, medicamentoItem)"
                        @input="handleInput(item, 'quantidadeSolicitada', $event)"
                        class="my-auto qunantidade"
                        name="Solicitado"
                        step=".001"
                        type="number"
                    />
                </template>

                <template v-slot:cell(enviadoDrsEm)="{ item }">
                    <rkm-form-date-picker
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido || !!item.naoRetiradaMotivoId || !item.quantidadeSolicitada"
                        :max-date="item.retiradoDrsEm ? getFormatedDate(item.retiradoDrsEm, 'DD/MM/YYYY') : null"
                        :validations="getTableValidation(item, 'enviadoDrsEm')"
                        :value="item.enviadoDrsEm"
                        @input="handleInput(item, 'enviadoDrsEm', $event, medicamentoIndex)"
                        class="my-auto data"
                        name="Envio DRS"
                    />
                </template>

                <template v-slot:cell(retiradoDrsEm)="{ item }">
                    <rkm-form-date-picker
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido || !!item.naoRetiradaMotivoId || !item.enviadoDrsEm"
                        :max-date="item.retiradoPacienteEm ? getFormatedDate(item.retiradoPacienteEm, 'DD/MM/YYYY') : null"
                        :min-date="item.enviadoDrsEm ? getFormatedDate(item.enviadoDrsEm, 'DD/MM/YYYY') : null"
                        :validations="getTableValidation(item, 'retiradoDrsEm')"
                        :value="item.retiradoDrsEm"
                        @input="handleInput(item, 'retiradoDrsEm', $event, medicamentoIndex)"
                        class="my-auto data"
                        name="Retirada DRS"
                    />
                </template>

                <template v-slot:cell(quantidadeRetirada)="{ item }">
                    <rkm-form-input
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido || !!item.naoRetiradaMotivoId || !item.retiradoDrsEm"
                        :validations="getTableValidation(item, 'quantidadeRetirada')"
                        :value="item.quantidadeRetirada"
                        @input="handleInput(item, 'quantidadeRetirada', $event)"
                        class="my-auto qunantidade"
                        name="Retirado"
                        step=".001"
                        type="number"
                    />
                </template>

                <template v-slot:cell(retiradoPacienteEm)="{ item }">
                    <rkm-form-date-picker
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido || !!item.naoRetiradaMotivoId || !item.retiradoDrsEm"
                        :min-date="item.retiradoDrsEm ? getFormatedDate(item.retiradoDrsEm, 'DD/MM/YYYY') : null"
                        :validations="getTableValidation(item, 'retiradoPacienteEm')"
                        :value="item.retiradoPacienteEm"
                        @input="handleInput(item, 'retiradoPacienteEm', $event, medicamentoIndex)"
                        class="my-auto data"
                        name="Retirada do paciente"
                    />
                </template>

                <template v-slot:cell(usuarioAtendente)="{ item }">
                    <rkm-form-input-autocomplete
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido || !item.quantidadeSolicitada"
                        :repository="repositories.usuario"
                        :search-fields="fields.autocomplete.usuario"
                        :validations="getTableValidation(item, 'usuarioAtendente')"
                        class="my-auto"
                        name="Atendente"
                        text-field="cidadaoNome"
                        uppercase
                        v-model="item.usuarioAtendente"
                    />
                </template>

                <template v-slot:cell(status)="{ index, item }">
                    <rkm-icon
                        icon="info-circle"
                        :id="uniqueId(`status-${medicamentoItem.material.id}-${index}`)"
                    />

                    <rkm-tooltip :target="uniqueId(`status-${medicamentoItem.material.id}-${index}`)">
                        {{ item.status.nome }}
                    </rkm-tooltip>
                </template>

                <template v-slot:cell(actions)="{ index, item }">
                    <rkm-button
                        v-if="data.additionals.permiteEdicao && !processoDevolvido && !item.naoRetiradaMotivoId && !!item.enviadoDrsEm && !item.retiradoPacienteEm"
                        @click="abrirNaoRetirada(item)"
                        color="warning"
                        small
                    >
                        Não retirada
                    </rkm-button>

                    <rkm-button
                        v-if="data.additionals.permiteEdicao && !processoDevolvido && !!item.naoRetiradaMotivoId"
                        @click="desfazerNaoRetirada(item)"
                        small
                    >
                        Desfazer não retirada
                    </rkm-button>

                    <rkm-button
                        v-if="index !== 0 && index === medicamentoItem.meses.length - 1"
                        :disabled="!data.additionals.permiteEdicao || processoDevolvido"
                        @click="excluirMes(medicamentoItem, item, index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-form>

        <rkm-modal
            ref="ModalNaoRetirada"
            title="Não retirada"
        >
            <rkm-form ref="FormNaoRetirada">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.naoRetiradaMotivos"
                            :validations="validations.naoRetiradaMotivo"
                            label="Motivo"
                            show-default-option
                            text-field="nome"
                            v-model="formNaoRetirada.motivoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :disabled="formNaoRetirada.motivoId !== enums.processoNaoRetiradaMotivo.OUTRO"
                            :validations="validations.naoRetiradaJustificativa"
                            label="Justificativa"
                            maxlength="150"
                            v-model="formNaoRetirada.justificativa"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{ cancel }">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="$refs.FormNaoRetirada.validate(confirmarNaoRetirada)"
                    color="primary"
                >
                    Confirmar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Others.
import { repository, object, data } from '@/mixins'
import processoItemMesStatus from '@/enums/farmacia/alto-custo/processoItemMesStatus'
import processoNaoRetiradaMotivo from '@/enums/farmacia/alto-custo/processoNaoRetiradaMotivo'
import processoTipo from '@/enums/farmacia/alto-custo/processoTipo'

export default {
    computed: {
        processoDevolvido() {

            return this.data.model.devolucoesProcesso.some(d => !d.reabertoEm)
        },
        queryStringParams() {

            return {
                material: {
                    is_alto_custo: true,
                    not_id: this.data.model.itens.map(i => i.material.id),
                },
            }
        },
        fields() {

            return {
                autocomplete: {
                    material: [
                        { key: 'codigo_material', searchable: true },
                        { key: 'descricao', searchable: true },
                    ],
                    usuario:  [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ],
                },
                table: {
                    meses: [
                        { key: 'mes', label: 'Mês', class: 'col-min text-nowrap' },
                        { key: 'quantidadeSolicitada', label: 'Solicitado', class: 'col-min' },
                        { key: 'enviadoDrsEm', label: 'Envio DRS' },
                        { key: 'retiradoDrsEm', label: 'Retirada DRS' },
                        { key: 'quantidadeRetirada', label: 'Retirado', class: 'col-min' },
                        { key: 'retiradoPacienteEm', label: 'Retirada do paciente' },
                        { key: 'usuarioAtendente', label: 'Atendente' },
                        { key: 'status', label: 'Status', class: 'col-min text-center' },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center text-nowrap' },
                    ]
                }
            }
        },
        validations() {

            return {
                material: { required: true },
                mes: { required: true },
                naoRetiradaMotivo: { required: true },
                naoRetiradaJustificativa: {
                    required: this.formNaoRetirada.motivoId === this.enums.processoNaoRetiradaMotivo.OUTRO,
                    max: 150,
                },
            }
        },
    },
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        form: {
            mesValue: 6,
        },
        formNaoRetirada: {
            mes: null,
            motivoId: null,
            justificativa: null,
        },
        model: {
            id: null,
            material: null,
            meses: [],
        },
        modelMes: {
            id: null,
            mes: null,
            quantidadeSolicitada: 0,
            enviadoDrsEm: null,
            retiradoDrsEm: null,
            quantidadeRetirada: null,
            retiradoPacienteEm: null,
            usuarioAtendente: null,
            status: null,
            naoRetiradaMotivoId: null,
            naoRetiradaJustificativa: null,
        },
        enums: {
            processoItemMesStatus,
            processoNaoRetiradaMotivo,
            processoTipo,
        },
    }),
    methods: {
        validate() {

            return this.$refs.FormMeses.validate()
        },
        add() {

            const model = this.clone(this.model)

            for (let i = 1; i <= this.form.mesValue; i++) {

                this.addMes(model, i)
            }

            this.data.model.itens.push(model)

            this.resetForm()
        },
        addMes(medicamento, numeroMes) {

            const modelMes = this.clone(this.modelMes)

            modelMes.mes = numeroMes
            modelMes.usuarioAtendente = this.clone(this.data.additionals.usuarioLogado)

            this.handleMes(modelMes)

            medicamento.meses.push(modelMes)
        },
        resetForm() {

            this.form.mesValue = 3

            this.model.id = null
            this.model.material = null
            this.model.meses = []

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleInput(item, key, value, medicamentoIndex = null) {

            if (['quantidadeSolicitada', 'quantidadeRetirada'].includes(key)) {

                if (value && !isNaN(value) && value.indexOf('.') !== -1) {

                    value = value.split('.')
                    value = `${value[0]}.${value[1].substring(0, 3)}`
                }
            }

            item[key] = value

            if (key === 'quantidadeSolicitada') {

                item['quantidadeRetirada'] = value;
            }

            if (value && ['enviadoDrsEm', 'retiradoDrsEm', 'retiradoPacienteEm'].includes(key)) {

                this.data.model.itens.filter((_, i) => i != medicamentoIndex).map(currentItem => {

                    const currentMes = currentItem.meses.find(m => m.mes === item.mes)

                    if (currentMes && !currentMes.naoRetiradaMotivoId) {

                        if (key === 'enviadoDrsEm' && !currentMes.enviadoDrsEm) {

                            currentMes.enviadoDrsEm = this.clone(item.enviadoDrsEm)
                            this.handleMes(currentMes)
                        }
                        else if (key === 'retiradoDrsEm'
                            && !!currentMes.enviadoDrsEm
                            && !currentMes.retiradoDrsEm
                        ) {

                            currentMes.retiradoDrsEm = this.clone(item.retiradoDrsEm)
                            this.handleMes(currentMes)
                        }
                        else if (key === 'retiradoPacienteEm'
                            && !!currentMes.retiradoDrsEm
                            && !currentMes.retiradoPacienteEm
                        ) {

                            currentMes.retiradoPacienteEm = this.clone(item.retiradoPacienteEm)
                            this.handleMes(currentMes)
                        }
                    }
                })
            }

            this.handleMes(item)
        },
        handleQuantidadeSolcitadaChange(index, item, medicamentoItem) {

            if (index === 0 && item.quantidadeSolicitada && medicamentoItem.meses.length > 1) {

                this.showConfirmation(
                    'Deseja replicar a quantidade solicitada para os demais meses?',
                    async () => {

                        medicamentoItem.meses
                            .filter(m => m.mes > item.mes)
                            .map(mes => {

                                mes.quantidadeSolicitada = item.quantidadeSolicitada
                                mes.quantidadeRetirada = mes.quantidadeSolicitada
                            })
                    }
                )
            }
        },
        handleMes(item) {

            if (item.mes > 1 && !!item.enviadoDrsEm) {

                this.data.model.tipoId = this.enums.processoTipo.CONTINUIDADE
            }

            if (!item.quantidadeSolicitada) {

                item.enviadoDrsEm = null
                item.retiradoDrsEm = null
                item.quantidadeRetirada = item.quantidadeSolicitada
                item.retiradoPacienteEm = null
            }
            else if (!item.enviadoDrsEm) {

                item.retiradoDrsEm = null
                item.quantidadeRetirada = item.quantidadeSolicitada
                item.retiradoPacienteEm = null
            }
            else if (!item.retiradoDrsEm) {

                item.quantidadeRetirada = item.quantidadeSolicitada
                item.retiradoPacienteEm = null
            }

            item.status = this.getStatus(item)
        },
        getStatus(item) {

            const get = id => this.data.form.status.find(s => s.id == id)

            if (item.naoRetiradaMotivoId) {

                return get(this.enums.processoItemMesStatus.NAO_RETIRADO)
            }

            if (this.processoDevolvido) {

                return get(this.enums.processoItemMesStatus.PROCESSO_DEVOLVIDO)
            }

            if (!item.enviadoDrsEm) {

                return get(this.enums.processoItemMesStatus.PENDENTE_ENVIO_DRS)
            }

            if (item.enviadoDrsEm && !item.retiradoDrsEm) {

                return get(this.enums.processoItemMesStatus.PENTENDE_RETIRADA_DRS)
            }

            if (item.enviadoDrsEm && item.retiradoDrsEm && !item.retiradoPacienteEm) {

                return get(this.enums.processoItemMesStatus.PENDENTE_RETIRADA_PACIENTE)
            }

            if (item.enviadoDrsEm && item.retiradoDrsEm && item.retiradoPacienteEm) {

                return get(this.enums.processoItemMesStatus.RETIRADO_PACIENTE)
            }
        },
        getTableValidation(item, key) {

            switch (key) {

                case 'quantidadeSolicitada': return {
                    required: true,
                    min_value: 0.001,
                    max_value: 999.999,
                }
                case 'enviadoDrsEm': return {
                    required: !!item.retiradoDrsEm,
                }
                case 'retiradoDrsEm': return {
                    required: !!item.retiradoPacienteEm,
                }
                case 'quantidadeRetirada': return {
                    required: true,
                    min_value: 0.001,
                    max_value: item.quantidadeSolicitada,
                }
                case 'retiradoPacienteEm': return {}
                case 'usuarioAtendente': return {}
            }
        },
        getNumeroProximoMes(medicamento) {

            return medicamento.meses[medicamento.meses.length - 1].mes + 1
        },
        excluir(medicamento, index) {

            let message = 'Deseja realmente excluir o medicamento?'

            if (medicamento.meses.some(m => !!m.enviadoDrsEm)) {

                message = `O medicamento possui movimentações. ${message}`
            }

            this.showDeleteConfirmation(
                message,
                async () => this.data.model.itens.splice(index, 1)
            )
        },
        excluirMes(medicamento, mes, index) {

            let message = 'Deseja realmente excluir o mês?'

            if (mes.enviadoDrsEm) {

                message = `O mês possui movimentações. ${message}`
            }

            this.showDeleteConfirmation(
                message,
                async () => medicamento.meses.splice(index, 1)
            )
        },
        abrirNaoRetirada(mes) {

            this.formNaoRetirada = {
                mes,
                motivoId: null,
                justificativa: null,
            }

            this.$refs.ModalNaoRetirada.show()
        },
        confirmarNaoRetirada() {

            const mes = this.formNaoRetirada.mes

            mes.naoRetiradaMotivoId = this.formNaoRetirada.motivoId
            mes.naoRetiradaJustificativa = this.formNaoRetirada.motivoId === this.enums.processoNaoRetiradaMotivo.OUTRO
                ? this.formNaoRetirada.justificativa
                : null
            mes.status = this.getStatus(mes)

            this.$refs.ModalNaoRetirada.hide()
        },
        desfazerNaoRetirada(mes) {

            this.showConfirmation(
                'Deseja desfazer a não retirada?',
                async () => {

                    mes.naoRetiradaMotivoId = null
                    mes.naoRetiradaJustificativa = null
                    mes.status = this.getStatus(mes)
                }
            )
        },
    },
    mixins: [repository, object, data],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        processoDevolvido() {

            this.data.model.itens.forEach(i => i.meses.forEach(mes => mes.status = this.getStatus(mes)))
        },
    },
}
</script>

<style scoped>
.table-meses >>> .table-meses-header-footer {
    color: var(--gray-dark);
    font-weight: 600;
    background: #f1f1f1;
    padding: 0.5rem;
    border: 1px solid #dee2e6;
}
.table-meses >>> .data {
    max-width: 240px;
}
.table-meses >>> .qunantidade {
    min-width: 120px;
}
</style>